import React, { useEffect, useState } from 'react'

import queryString from 'query-string'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { useAuth, useProtectedPage } from '../../../../context/AuthContext'
import Loading from '../../../../templates/UI/Loading/Loading'
import AdvertiserTeam from '../AdvertiserTeam/AdvertiserTeam'
import AffiliatesByPrioritySummary from '../AffiliateByPrioritySummary/AffiliatesByPrioritySummary'
import AffiliateHealthSummary from '../AffiliateHealthSummary/AffiliateHealthSummary'
import AffiliateTeam from '../AffiliateTeam/AffiliateTeam'
import AvatarSummaryStats from '../Avatar/AvatarSummaryStats/AvatarSummaryStats'
import BizdevTeam from '../BizdevTeam/BizdevTeam'
import CampaignsByStatusSummary from '../CampaignsByStatusSummary/CampaignsByStatusSummary'
import ComplianceTeam from '../ComplianceTeam/ComplianceTeam'
import MarginSummary from '../MarginSummary/MarginSummary'

export default function Owner({ manager, showSystemMessage }) {
    const auth = useAuth()
    useProtectedPage(auth.permissions, 'owner_dashboard')

    const history = useHistory()    
    const location = useLocation()
    let urlParams = queryString.parse(location.search)

    const [dataLoaded, setDataLoaded] = useState(true)
    const [option, setOption] = useState(urlParams.view ? urlParams.view : 'operations')

    const setView = (option) => {
        setOption(option)
        history.push(`/dashboard?view=${option}`)
    }
    
    useEffect(()=>{
        let urlParams = queryString.parse(location.search)
        setOption(urlParams.view ? urlParams.view : 'operations')
    },[location])

    let statLabelClasses = 'btn btn-secondary'

    return (
        <React.Fragment>
            {dataLoaded ? (
                <React.Fragment>
                    <div className="page-header d-flex align-items-center">
                        <h1 className="mb-h1 d-flex align-items-center">
                            <div>Owner Dashboard</div>
                            <div className="d-flex justify-content-center">
                                <div className="mx-2 btn-group btn-group-sm btn-group-toggle w-75" data-toggle="buttons" role="group">
                                    <label className={option === 'operations' ? statLabelClasses + ' active' : statLabelClasses}>
                                        <input type="radio" name="statOptions" id="option1" className="change-graph-option" autoComplete="off" value="operations" onClick={(e) => setView(e.target.value)} /> Operations
                                    </label>
                                    <label className={option === 'teams' ? statLabelClasses + ' active' : statLabelClasses}>
                                        <input type="radio" name="statOptions" id="option2" className="change-graph-option" autoComplete="off" value="teams" onClick={(e) => setView(e.target.value)} /> Teams
                                    </label>
                                </div>
                            </div>
                        </h1>
                    </div>
                    {option === 'operations' ? (
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <MarginSummary manager={manager} showSystemMessage={showSystemMessage} />
                                        <CampaignsByStatusSummary showSystemMessage={showSystemMessage} />     
                                    </div>
                                    <div className="col-lg-6">
                                        <AffiliateHealthSummary manager={manager} showSystemMessage={showSystemMessage} />
                                        <AffiliatesByPrioritySummary showSystemMessage={showSystemMessage} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="row">
                                    <div className="col-md-6">
                                        <AvatarSummaryStats showSystemMessage={showSystemMessage} />
                                    </div>
                                </div>                                
                            </div>
                        </div>
                    ) : (
                        <div className="row">
                            <div className="col-lg-8">
                                <AffiliateTeam showSystemMessage={showSystemMessage} mode="all" />
                                <AdvertiserTeam showSystemMessage={showSystemMessage} mode="all" />
                                <BizdevTeam showSystemMessage={showSystemMessage} mode="all" />
                                <ComplianceTeam showSystemMessage={showSystemMessage} />
                            </div>
                        </div>
                    )}
                </React.Fragment>
            ) : (
                <Loading></Loading>
            )}
        </React.Fragment>
    )
}
